import React from 'react';
import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { formStyles as styles } from './styles';

export default function Step3OrderSummary({
    descriptionValue,
    setDescriptionValue,
    orderCode,
    getHerdsmanName,
    phoneNumberValue,
    getReceiptTimeName,
    deliveryType,
    selectedCommune,
    selectedDistrict
}) {
    const { watch, setValue } = useFormContext();
    const formValues = watch();

    return (
        <div>
            <div style={styles.stepHeader}>
                <svg style={styles.stepHeaderIcon} fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                </svg>
                <h3 style={styles.stepHeaderTitle}><span>Chi tiết đơn hàng</span></h3>
            </div>

            {/* Description Field */}
            <div style={{ marginBottom: '30px' }}>
                <label style={{ ...styles.formLabel, fontSize: '16px', display: 'block', marginBottom: '10px' }}>
                    <span>Mô tả (không bắt buộc)</span>
                </label>
                <textarea className="form-control" rows="3"
                    name="description"
                    value={descriptionValue}
                    placeholder="Thêm ghi chú về đơn hàng của bạn..."
                    onChange={(e) => {
                        setDescriptionValue(e.target.value);
                        setValue("description", e.target.value);
                    }}
                    style={{ resize: 'vertical', minHeight: '80px' }}
                />
            </div>

            {/* Order Summary */}
            <div style={styles.summaryContainer}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <svg style={{ width: '24px', height: '24px', color: '#e74c3c', marginRight: '10px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <h4 style={{ margin: 0, fontWeight: 'bold', color: '#2c3e50', fontSize: '18px' }}><span>Tóm tắt đơn hàng</span></h4>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Mã đăng ký</span></span>
                            <span style={styles.summaryItemValue}><span>{orderCode || "Chưa có"}</span></span>
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Người nhận</span></span>
                            <span style={styles.summaryItemValue}><span>{getHerdsmanName()}</span></span>
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Số điện thoại</span></span>
                            <span style={styles.summaryItemValue}><span>{phoneNumberValue || "Chưa nhập"}</span></span>
                        </div>
                        <div>
                            <span style={styles.summaryItemTitle}><span>Số lượng</span></span>
                            <span style={styles.summaryItemValue}><span>{formValues.quatity || "0"} suất</span></span>
                        </div>
                    </div>

                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Ngày nhận</span></span>
                            <span style={styles.summaryItemValue}>
                                <span>{formValues.orderDate ? dayjs(formValues.orderDate).format('DD/MM/YYYY') : "Chưa chọn"}</span>
                            </span>
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Thời gian nhận</span></span>
                            <span style={styles.summaryItemValue}><span>{getReceiptTimeName()}</span></span>
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <span style={styles.summaryItemTitle}><span>Hình thức nhận hàng</span></span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {deliveryType == 0 ? (
                                    <>
                                        <svg style={{ width: '20px', height: '20px', color: '#e74c3c' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                                            <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
                                        </svg>
                                        <span style={styles.summaryItemValue}><span>Giao nhận</span></span>
                                    </>
                                ) : (deliveryType == 1 ? (
                                    <>
                                        <svg style={{ width: '20px', height: '20px', color: '#e74c3c' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
                                        </svg>
                                        <span style={styles.summaryItemValue}><span>Tự lấy</span></span>
                                    </>
                                ) : (
                                    <>
                                        <svg style={{ width: '20px', height: '20px', color: '#e74c3c' }} fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2 2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                                        </svg>
                                        <span style={styles.summaryItemValue}><span>Ăn tại nhà hàng</span></span>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Address Info (only if delivery) */}
                {deliveryType == 0 && (
                    <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #dee2e6' }}>
                        <span style={styles.summaryItemTitle}><span>Địa chỉ giao hàng</span></span>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                            <svg style={{ width: '18px', height: '18px', color: '#e74c3c', marginTop: '2px', flexShrink: 0 }} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                            </svg>
                            <div style={{ flex: 1 }}>
                                <span style={{ ...styles.summaryItemValue, display: 'block' }}>
                                    <span>{formValues.address || "Chưa nhập địa chỉ"}</span>
                                </span>
                                <span style={{ fontSize: '14px', color: '#7f8c8d' }}>
                                    <span>{selectedCommune?.label || "Chưa chọn"}, {selectedDistrict?.label || "Chưa chọn"}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
